import * as API from '../api'
import { downloadPng, fileNamePart } from '../utils/downloads'

export const FETCHING_FISPQS = 'FETCHING_FISPQS'
export const FETCH_FISPQS = 'FETCH_FISPQS'
export const FETCH_FISPQS_ERROR = 'FETCH_FISPQS_ERROR'
export const FETCHING_AREA_FDS_QRCODE = 'FETCHING_AREA_FDS_QRCODE'
export const FETCH_AREA_FDS_QRCODE = 'FETCH_AREA_FDS_QRCODE'
export const FETCH_AREA_FDS_QRCODE_ERROR = 'FETCH_AREA_FDS_QRCODE_ERROR'

export const fetchProductsFispq = (
  areaId,
  page,
  rowsPerPage,
  orderBy,
  order,
  issue_initial_date = '',
  issue_final_date = '',
  expiration_initial_date = '',
  expiration_final_date = ''
) => {
  return dispatch => {
    dispatch({
      type: FETCHING_FISPQS,
      value: true
    })

    return API.fispq
      .getProductsFispq(
        areaId,
        page,
        rowsPerPage,
        orderBy,
        order,
        issue_initial_date,
        issue_final_date,
        expiration_initial_date,
        expiration_final_date)
      .then(response => {
        const { data = {} } = response
        const { can_change_status: canChangeStatus, items, last_update, total_records, pagination } = data

        dispatch({
          type: FETCH_FISPQS,
          canChangeStatus,
          items,
          last_update,
          total_records,
          pagination
        })
      })
      .catch(err => {
        dispatch({
          type: FETCH_FISPQS_ERROR
        })
      })
  }
}

// Baixa o PNG do QR Code que abre a página pública com todas as FDS ativas da área.
// O nome da área vira nome de arquivo: depois de trocar de área no Header ele vem como
// "CÓDIGO - NOME", e barras ou espaços não devem chegar ao download.
export const fetchAreaFdsQrCode = (areaId, areaName = '') => {
  return dispatch => {
    dispatch({ type: FETCHING_AREA_FDS_QRCODE })

    return API.fispq
      .getAreaFdsQrCode(areaId)
      .then(response => {
        dispatch({ type: FETCH_AREA_FDS_QRCODE })

        downloadPng(response.data, `fds-area-${fileNamePart(areaName, areaId)}.png`)
      })
      .catch(err => {
        dispatch({ type: FETCH_AREA_FDS_QRCODE_ERROR })
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/fispq.js